<template>
  <div class="row myrow content-mb-42">
    <div class="col-xs-12 mycol">
      <table class="co-executor">
        <thead>
          <tr>
            <th class="tab-wid-80">№<br /></th>
            <th class="tab-wid-80">Группа</th>
            <th class="tab-wid-122">
              Код оборудования
            </th>
            <th class="tab-wid-250">
              Вид оборудования
            </th>
            <th class="tab-wid-250">
              Наименование закупаемого оборудования
            </th>
            <th class="tab-wid-250">
              Количество
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody v-for="(item, index) in project.PURCHASED_EQUIPMENT.items">
          <System_equipment_list
            :item="item"
            :index="index"
            v-bind:key="index"
          ></System_equipment_list>
        </tbody>
      </table>
      <div class="add-row" v-show="!$parent.$parent.projectDisabled">
        <a class="link-add-row" v-on:click="addItem">Добавить оборудование</a>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import System_equipment_list from "@/components/project/form/lists/SystemEquipmentList";
import { FETCH_DIRECTORY } from "@/store/actions.type";
import { mapGetters } from "vuex";

export default {
  name: "system_equipment",
  props: ["project"],
  components: {
    System_equipment_list
  },
  mounted() {
    this.$store
      .dispatch(FETCH_DIRECTORY, ["tree/group_med_oborudovanie"])
      .then(() => {}, this);
  },
  methods: {
    hasError(col, field) {
      if (
        typeof this.$parent.$parent.systemEquipmentErrors !== "undefined" &&
        typeof this.$parent.$parent.systemEquipmentErrors[col] !== "undefined"
      ) {
        if (
          typeof this.$parent.$parent.systemEquipmentErrors[col][field] !==
          "undefined"
        ) {
          return true;
        }
      }
      return false;
    },
    errorText(col, field) {
      if (
        typeof this.$parent.$parent.systemEquipmentErrors !== "undefined" &&
        typeof this.$parent.$parent.systemEquipmentErrors[col] !== "undefined"
      ) {
        if (
          typeof this.$parent.$parent.systemEquipmentErrors[col][field] !==
          "undefined"
        ) {
          return this.$parent.$parent.systemEquipmentErrors[col][field];
        }
      }
      return "";
    },
    removeError(col, field) {
      if (
        typeof this.$parent.$parent.systemEquipmentErrors !== "undefined" &&
        typeof this.$parent.$parent.systemEquipmentErrors[col] !== "undefined"
      ) {
        if (
          typeof this.$parent.$parent.systemEquipmentErrors[col][field] !==
          "undefined"
        ) {
          Vue.delete(this.$parent.$parent.systemEquipmentErrors[col], field);
        }
      }
      return false;
    },
    addItem() {
      if (typeof this.project.PURCHASED_EQUIPMENT === "undefined") {
        this.project.PURCHASED_EQUIPMENT = {
          items: []
        };
      }
      this.project.PURCHASED_EQUIPMENT.items.push({});
    },
    deleteItem(index) {
      this.project.PURCHASED_EQUIPMENT.items.splice(index, 1);
    }
  },
  computed: {
    ...mapGetters(["directory"])
  }
};
</script>

<style scoped></style>
